import { render, staticRenderFns } from "./urgentDayTypeBag.vue?vue&type=template&id=21d6b4f2&scoped=true&"
import script from "./urgentDayTypeBag.vue?vue&type=script&lang=js&"
export * from "./urgentDayTypeBag.vue?vue&type=script&lang=js&"
import style0 from "./urgentDayTypeBag.vue?vue&type=style&index=0&id=21d6b4f2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d6b4f2",
  null
  
)

export default component.exports